export class FiAppSettings {
    static readonly NumberOfRecordsPerPage = 30;
    static readonly NumberOfRecordsPerPageForGlobalSearch = 100;
    static readonly StartDelay = 500; // delay before all widgets except news feed start load data,
    static readonly AutoSaveInterval = 30000; // documents autosave interval in milliseconds,
    static readonly DefaultTranslationStatus = 1;
    static readonly CountDownTime = 2 * 60 * 60 * 1000; // by default 2 hrs,

    static readonly InactivityCountDownNotificationTime = 1 * 60 * 60 * 1000; // by default 1h,
    static readonly DefaultPaymentCurrency = 1;

    static readonly DefaultMediaBankImageExtension = '.jpg';
    static readonly DefaultMediaBankPdfExtension = '.pdf';
    static readonly ExcelContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    static readonly CheckConversationsChangesInterval = 20 * 60 * 1000; // every 20 minutes sync chat data with server

    static readonly Billing = {
        AccountNo: '8321-2, 4 462 533-3',
        BIC: 'SWEDSESS',
        IBAN: 'SE61 8000 0832 1200 4462 5333',
    };
}
